import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const Stop = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 16 16"
    fill={'none'}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M10.907.779H5.093c-.781 0-1.503.417-1.893 1.093L.293 6.907c-.39.676-.39 1.51 0 2.186L3.2 14.128a2.185 2.185 0 0 0 1.893 1.093h5.814c.781 0 1.502-.416 1.893-1.093l2.907-5.035c.39-.676.39-1.51 0-2.186L12.8 1.872A2.185 2.185 0 0 0 10.907.779Z"
        fill="#D1D9E9"
      />
      <Path
        d="M5.093 13.933a.9.9 0 0 1-.778-.449L1.408 8.45a.9.9 0 0 1 0-.898l2.907-5.035a.9.9 0 0 1 .778-.45h5.814a.9.9 0 0 1 .778.45l2.907 5.035a.9.9 0 0 1 0 .898l-2.907 5.035a.9.9 0 0 1-.778.45H5.093Z"
        fill="#596379"
      />
      <Path
        d="M11.467 8.428c-.179.323-.18 1.047-.18 1.055 0 0-.013 2.804-2.038 2.804H7.427c-1.494 0-2.339-1.53-2.339-2.846V6.52a.612.612 0 0 1 1.224 0v-1.24a.612.612 0 0 1 1.224 0v-.954a.612.612 0 1 1 1.224 0v.77a.612.612 0 1 1 1.224 0V8.38a3.04 3.04 0 0 1 .262-.63.698.698 0 0 1 .948-.272h.002a.699.699 0 0 1 .271.95Z"
        fill="#fff"
      />
      <Path
        d="M6.541 8.462a.229.229 0 0 1-.229-.229V5.28a.612.612 0 0 1 .841-.567.612.612 0 0 0-.383.567v2.954a.229.229 0 0 1-.229.23Z"
        fill="#F1B986"
      />
      <Path
        d="M7.765 8.418a.229.229 0 0 1-.229-.229V4.325a.612.612 0 0 1 .841-.567.612.612 0 0 0-.383.567V8.19a.229.229 0 0 1-.229.23ZM8.99 8.148a.229.229 0 0 1-.23-.228V5.096a.612.612 0 0 1 .841-.568.612.612 0 0 0-.383.568V7.92a.229.229 0 0 1-.229.228ZM6.541 8.462a.229.229 0 0 1-.229-.229V5.28a.612.612 0 0 1 .841-.567.612.612 0 0 0-.383.567v2.954a.229.229 0 0 1-.229.23Z"
        fill="#D1D9E9"
      />
      <Path
        d="M7.885 12.287h-.458c-1.494 0-2.338-1.53-2.338-2.846V6.52a.612.612 0 0 1 .84-.568.612.612 0 0 0-.383.568V9.44c0 1.316.845 2.846 2.339 2.846ZM10.246 7.75c-.089.16-.162.325-.22.495a1.462 1.462 0 0 1-.042.134c-.16.427-.118.862-.117.864-.817 0-1.492.608-1.598 1.396a.21.21 0 0 0 .19.236.213.213 0 0 0 .219-.138c.5-1.322 1.76-1.117 1.76-1.117-.321-.948.422-2.301.756-2.143a.698.698 0 0 0-.948.273Z"
        fill="#D1D9E9"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Stop
